<div class="title-components">
    <h1>Política de Calidad</h1>
  </div>
  
  <!--&================== DIVIDER BUTONS LIBRARY ==================&-->
  <div class="divider-butons-M">
    <button
      [class.Is-Disabled]="
        !UserService.UserRoleGeneralIn([RolesGeneral.QualityPolicies])
      "
      [disabled]="
        !UserService.UserRoleGeneralIn([RolesGeneral.QualityPolicies])
      "
      (click)="OpenModalIsUpdate(false, null)"
      class="btn-icon-text"
    >
      <i class="fa-solid fa-plus"></i><span class="text">Agregar política de calidad</span>
    </button>
  </div>
  
  <ng-container *ngIf="All_Qualitys.length > 0 && LoadPage; else Not_Quality">
    <div class="Container-Card-Qualitys">
      <div class="card-wrap" *ngFor="let Quality of All_Qualitys">
        <div class="card-header {{ Type_Extension_Class(Quality.Extension) }}">
          <img
            src="./assets/Global/icon/{{ Type_Extension_Img(Quality.Extension) }}"
            alt=""
            srcset=""
          />
          <div
            *ngIf="
              UserService.UserRoleGeneralIn([RolesGeneral.QualityPolicies])
            "
            class="Options-Quality"
          >
            <button
              (click)="OpenModalIsUpdate(true, Quality)"
              class="Btn-Option button-square Upload-M"
            >
              <i class="fa-solid fa-upload"></i>
            </button>
            <button
              (click)="Delete_Quality(Quality)"
              class="Btn-Option button-square Delete-M"
            >
              <i class="fa-regular fa-trash-can"></i>
            </button>
          </div>
        </div>
        <div class="card-content">
          <h1 class="card-title">{{ Cut_Name(Quality.Name) }}</h1>
          <p class="card-text">
            Descargue presionando sobre el boton descargar
          </p>
          <button
            (click)="Download_Quality(Quality)"
            class="card-btn {{ Type_Extension_Class(Quality.Extension) }}"
          >
            Descargar
          </button>
        </div>
      </div>
    </div>
  </ng-container>
  
  <ng-template #Not_Quality>
    <div class="Container-Preview container-global-components">
      <div class="Not-Quality">
        <div class="Img-Not">
          <img src="./assets/Global/Ilustrations/Not-Annexes_See.png" alt="" />
        </div>
        <div class="Text-Not-Quality">
          ¡Hola {{ NameUser() }}, aun no hay políticas de calidad para mostrar!
        </div>
      </div>
    </div>
  </ng-template>
  
  <!---===================== MODAL FOR ADD QualityS =====================--->
  <section class="Modal-Global" id="ModalAddQuality">
    <div class="wrapper">
      <div class="Pro-popup3 popup" id="Pro-popup3">
        <div class="Pro-inside3 popup-inside" id="Pro-inside3">
          <div class="Pro-backgrounds3 backgrounds">
            <div class="background"></div>
            <div class="background background2"></div>
            <div class="background background3"></div>
            <div class="background background4"></div>
            <div class="background background5"></div>
            <div class="background background6"></div>
          </div>
        </div>
        <div class="Pro-content3 content" id="Pro-content3">
          <button (click)="ToggleModalAddQuality(false)" class="Btn-Close">
            <i class="fa-solid fa-xmark"></i>
          </button>
          <div class="Content-Top">
            <h2>{{ !IsUpdate ? "Cargar" : "Actualizar" }} política de calidad</h2>
          </div>
  
          <div class="Content-body">
            <div class="Container-Drop">
              <input
                #AddQuality
                type="file"
                class="file"
                (dragover)="Load_File()"
                (dragleave)="Onload_File()"
                (change)="Load_Document_Quality($event)"
              />
              <div class="Drag-Drop" id="Drag-Drop">
                <div class="Img">
                  <img src="./assets/Global/Ilustrations/Add_Quality.jpg" alt="" />
                </div>
                <div class="Text">
                  Suelte su archivo aquí, o
                  <p>seleccione uno</p>
                </div>
                <div class="Subtitle">Soporta archivos PDF, PNG , PPTX ...</div>
              </div>
            </div>
  
            <div class="Container-Progress-Quality" id="Container-Progress-Quality">
              <div class="Title-Progress-Quality">
                <span>Cargando ...</span>
                <div id="Icon-Done" class="Icon-Done">
                  <i class="fa-solid fa-check"></i>
                </div>
              </div>
              <div class="Container-Subtitle-Quality">
                <div class="TextSubtitle">
                  <span id="TextProgress">0%</span>- un momento por favor
                </div>
              </div>
              <div class="Container-Progress-Bar-Quality">
                <div class="Progress-Bar-Quality" id="Progress-Bar-Quality"></div>
              </div>
            </div>
          </div>
          <div class="Content-Bottom Modal-Quality">
            <button
              (click)="ToggleModalAddQuality(false)"
              class="Btn-LCancel-Form Btn-Close-Modal"
            >
              <span>Cerrar</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
  
  <!---===================== MODAL FOR DOWNLOAD PROGRESS BAR FIN =====================--->
  <section class="Modal-Global" id="ProgressModal">
    <div class="Content-DownloadTable">
      <div class="Tittle-Table">
        <h2>Descargando política de calidad...</h2>
      </div>
      <div class="Body-Table">
        <div class="Container-progress-bar">
          <span class="Progress-Bar-Table" id="Progress-Bar-Table"></span>
        </div>
      </div>
    </div>
  </section>
  
  <!---===================== MODAL FOR LOADER COMPONENT =====================--->
  <div class="Container-Loader-Global" id="Loader">
    <div class="loader loader-1">
      <div class="loader-outter"></div>
      <div class="loader-inner"></div>
    </div>
  </div>
  